import { createAction } from '@reduxjs/toolkit';

export const changeBomColorNextGen = createAction('changeBomColorNextGen');
export const changePreviewNextGen = createAction('changePreviewNextGen');
